//Blues:
const bright_blue = '#06aed5'

//Greys:
const darkGrey = '#787878'
const grey = '#DDDBDB'

//Reds:
const bright_red = '#ad0005'
const muted_bright_red = '#C12025'
const pastel_bright_red = '#CC353A'

export{
    bright_blue,
    darkGrey,
    grey,
    bright_red,
    muted_bright_red,
    pastel_bright_red
}
